// extracted by mini-css-extract-plugin
export default {"searchWrapper":"searchWrapper-d4651357","searchIcon":"searchIcon-aafff287","search":"search-e7ad51c9"};